import { Fragment, useEffect, useState } from 'react'

import { Icon, IconBulldozer } from '@tabler/icons-react'
import styled, { keyframes } from 'styled-components'

import { useLocale } from '@/context/localeContext'

const BackAndForth = keyframes`
  0%,
  100% {
    transform: translateX(0) rotateY(0);
  }
  20% {
    transform: translateX(50px) rotateY(0);
  }
  30% {
    transform: translateX(50px) rotateY(180deg);
  }
  50% {
    transform: translateX(0) rotateY(180deg);
  }
  70% {
    transform: translateX(-50px) rotateY(180deg);
  }
  85% {
    transform: translateX(-50px) rotateY(0);
  }
`

const RelativeWrapper = styled.div`
  position: relative;
  width: 100%;
  min-height: 100px; // common height of the dozer
`

const Wrapper = styled.div<{ noBackground?: boolean }>`
  position: absolute;
  direction: ltr;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ noBackground }) =>
    noBackground ? 'none' : 'rgba(255, 255, 255, 0.5)'};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  & svg {
    color: ${({ theme }) => theme.colour.secondary._300};
    animation: ${BackAndForth} 3s linear infinite;
  }
`

const Loading = styled.span`
  ${({ theme }) => theme.font.caption02};
  color: ${({ theme }) => theme.colour.secondary._300};
`

type Props = {
  loading: boolean
  size?: number
  noBackground?: boolean
  relative?: boolean
  text?: string
  icon?: Icon
}

export const DozerLoading: React.FC<Props> = ({
  loading,
  noBackground,
  size = 64,
  relative,
  text,
  icon,
}) => {
  const { t } = useLocale()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!loading || !mounted) return null

  const OuterWrapper = relative ? RelativeWrapper : Fragment
  const Icon = icon || IconBulldozer

  return (
    <OuterWrapper>
      <Wrapper noBackground={noBackground}>
        <Icon size={size} stroke={1} />
        <Loading>{text ? text : t('common:labels.loading')}</Loading>
      </Wrapper>
    </OuterWrapper>
  )
}
